export const IATA_CODES_WITH_SKIP_PASSENGERS = ['DV'];
export function shouldSkipPassengers(passengersCount, iataCode) {
    return passengersCount === 1 || IATA_CODES_WITH_SKIP_PASSENGERS.includes(iataCode);
}
